import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';

// Ported 1:1 from the prototype `.empty` / `.e-ico`.
export const styles = {
  empty: {
    k9WMMc: "x2b8uid",
    kmVPX3: "x18nj0gh",
    kMwMTN: "xdxw5r1",
    $$css: true
  },
  icon: {
    kzqmXN: "x15yg21f",
    kZKoxP: "xnnlda6",
    kogj98: "x151z3yi",
    kaIpWk: "xgqmno8",
    kWkggS: "x13uruat",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kMwMTN: "xdxw5r1",
    $$css: true
  },
  title: {
    kMv6JI: "xdv2sak",
    kGuDYH: "x14k033y",
    k63SB2: "xomqrzn",
    kMwMTN: "x1oezkus",
    k1K539: "xzueoph",
    $$css: true
  },
  message: {
    kGuDYH: "x2pyw9z",
    kMwMTN: "xdxw5r1",
    kLWn49: "x1jjo3f5",
    $$css: true
  },
  action: {
    keoZOQ: "xv1leuy",
    k1xSpc: "x78zum5",
    kjj79g: "xl56j7k",
    $$css: true
  }
};